import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import {
  View,
} from '@uncinc/react-drupal-core';

import { Button, Main } from '../../../components';
import Page from '../../../containers/Page';
import useClasses from '../../../hooks/useClasses';
import useRoutes from '../../../hooks/useRoutes';

import './style.scss';

const PageDiaryOverview: React.FC = () => {
  const { t } = useTranslation();
  const { diary } = useRoutes();
  const { buildClass } = useClasses('PageDiaryOverview');

  const [currentPage, setCurrentPage] = useState(0);

  return (
    <Page className={buildClass()} title={t('pages.diary.overview.title')}>
      <Main className="col-lg-8 py-8 py-lg-12">
        <h1 className={buildClass('title')}>
          {t('pages.diary.overview.title')}
        </h1>

        <p className={buildClass('body')}>
          <Trans i18nKey="pages.diary.overview.body">
            <strong />
          </Trans>
        </p>

        <Button href={diary.add}>
          {t('pages.diary.overview.add_diary_entry')}
        </Button>

        <View
          id="diary_overview"
          display="block_1"
          page={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </Main>
    </Page>
  );
};

export default PageDiaryOverview;
